import React from 'react';
import './style.scss';
import shortid from 'shortid';

interface Props {
    labels: (string | React.ReactElement)[];
    step: number; /* should be start from 0 */
    setStep?: React.Dispatch<React.SetStateAction<number>> | undefined;
  }

const Slide: React.FC<Props> = (props) => {
  const {
    step, labels, setStep,
  } = props;
  return (
    <div className="mw-100 mb-4">
      <div
        className="stepper-slide-container px-2"
      >
        {labels.map((label, i) => (
          <div className="px-2" key={shortid.generate()}>
            <button
              type="button"
              onClick={setStep ? () => setStep(i) : undefined}
              className={`bg-transparent ${step === i ? 'text-active' : 'text'}`}
              disabled={!setStep}
            >
              {label}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Slide;
